// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.dialog-title mat-icon {
  color: #1976d2;
}

.conversation-dialog-content {
  min-width: 580px;
  max-height: 70vh;
  padding: 16px 24px;
  overflow-y: auto;
}

.conversation-messages {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0;
}

.empty-conversation {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
  color: #9e9e9e;
  gap: 12px;
}
.empty-conversation mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}
.empty-conversation p {
  margin: 0;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/ai-statistics/conversation-dialog/conversation-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;AACE;EACE,cAAA;AACJ;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;AAAF;AAEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAAJ;AAGE;EACE,SAAA;EACA,eAAA;AADJ","sourcesContent":[".dialog-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  mat-icon {\n    color: #1976d2;\n  }\n}\n\n.conversation-dialog-content {\n  min-width: 580px;\n  max-height: 70vh;\n  padding: 16px 24px;\n  overflow-y: auto;\n}\n\n.conversation-messages {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px 0;\n}\n\n.empty-conversation {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 16px;\n  color: #9e9e9e;\n  gap: 12px;\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n  }\n\n  p {\n    margin: 0;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
